import { ReactElement, useState } from 'react'
import { useFormikContext } from 'formik'
import { Button, Grid, H, P } from '@farewill/ui'

import CrematoriumPicker from 'components/form/crematorium-picker'
import { FormikValues } from './helpers'

export const Crematoria = (): ReactElement => {
  const { values, handleSubmit, setFieldValue } =
    useFormikContext<FormikValues>()

  const [crematorium, setCrematorium] = useState(
    values.quoteAttributes.crematorium
  )
  const [showCrematoriumPicker, setShowCrematoriumPicker] =
    useState(!!crematorium)

  const customerPostcode = values.contact?.addresses?.[0]?.postalCode

  const resetCrematorium = () => {
    setCrematorium(undefined)
    setFieldValue('quoteAttributes.crematoriumId', null)
    setFieldValue('quoteAttributes.crematorium', null)
    handleSubmit()
  }

  return (
    <Grid.Item>
      <H size="S" margin={['XL', 0, 'S']}>
        Choose a crematorium
      </H>
      <Grid data-testid="choose-a-crematorium">
        {!showCrematoriumPicker && (
          <Grid.Item>
            {' '}
            <P>
              Would they like to choose where the cremation will take place?
            </P>
            <Button.Primary
              type="button"
              onClick={() => setShowCrematoriumPicker(true)}
            >
              Choose crematoria
            </Button.Primary>
          </Grid.Item>
        )}
        {showCrematoriumPicker && (
          <CrematoriumPicker
            crematorium={crematorium}
            customerPostcode={customerPostcode}
            onReset={resetCrematorium}
            boldHeader={false}
            onCrematoriumChanged={(selectedCrematorium) => {
              setFieldValue(
                'quoteAttributes.crematoriumId',
                selectedCrematorium.id
              )
              setFieldValue('quoteAttributes.crematorium', selectedCrematorium)
              setCrematorium(selectedCrematorium)
              handleSubmit()
            }}
          />
        )}
      </Grid>
    </Grid.Item>
  )
}
